import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-layout-fab-button',
  templateUrl: './fab-button.component.html',
  styleUrls: ['./fab-button.component.scss']
})
export class LayoutFabButtonComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() isLarge: boolean;
  @Input() icon: string;
  @Input() color: string;
  @Input() isDisabled: boolean;

  @Input() hasSpinner: boolean;
  @Input() spinnerMode: string;
  @Input() spinnerTime: number; // segundos
  @Input() spinnerTooltip: string;

  @Input() class: string;

  @Output() onClick = new EventEmitter<string>();
  @Output() timeComplete = new EventEmitter<string>();

  spinnerValues: { [id: string]: number } = {};
  spinnerIntervals: { [id: string]: any } = {};

  constructor() { }

  ngOnInit(): void {
    if (this.hasSpinner && this.id) {
      this.initSpinner(this.id);
    }
  }

  clickButton($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.onClick.emit(this.id);

    if (this.hasSpinner && this.id) {
      console.log("Iniciando spinner manualmente para ID:", this.id);
      this.initSpinner(this.id);
    }
  }

  initSpinner(id: string) {
    if (this.spinnerIntervals[id]) {
      clearInterval(this.spinnerIntervals[id]);
    }

    this.spinnerValues[id] = 0;

    const intervalTime = (this.spinnerTime * 1000) / 100;

    this.spinnerIntervals[id] = setInterval(() => {
      if (this.spinnerValues[id] >= 100) {
        clearInterval(this.spinnerIntervals[id]);
        delete this.spinnerIntervals[id];

        this.timeComplete.emit(id);

        this.initSpinner(id);
        return;
      }
      this.spinnerValues[id] += 2;
    }, intervalTime);
  }

  ngOnDestroy(): void {
  }
}
